import { useState } from 'react';

import { ServiceUploadingOptions } from '@/utils/shared/uploadProgress';

type UseFormListProps<T> = {
  onSubmit: (
    data: T,
    options?: ServiceUploadingOptions,
  ) => void | Promise<unknown>;
  onError?: (error: Error) => void;
};

const useFormList = <T>({ onSubmit, onError }: UseFormListProps<T>) => {
  const [openForms, setOpenForms] = useState<string[]>([]);

  const addForm = () => {
    setOpenForms(prev => [...prev, crypto.randomUUID()]);
  };

  const removeForm = (id: string) => {
    setOpenForms(prev => prev.filter(formId => formId !== id));
  };

  const handleFormSubmit =
    (formId: string) =>
    async (data: T, options?: ServiceUploadingOptions) => {
      try {
        await onSubmit(data, options);
        removeForm(formId);
      } catch (error) {
        onError?.(error as Error);
      }
    };

  return { openForms, addForm, removeForm, handleFormSubmit };
};

export default useFormList;
